var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8c.6 0 1-.5.8-1-.5-1.6-2.5-3-6.8-3-4.4 0-6.3 1.4-6.8 3-.2.5.2 1 .8 1h12zM3 13.6c0-.3.3-.6.6-.6h12.8c.3 0 .6.3.6.6 0 1.3-1.1 2.4-2.4 2.4H5.4C4.1 16 3 14.9 3 13.6zM3.5 9C2.7 9 2 9.7 2 10.5S2.7 12 3.5 12h13c.8 0 1.5-.7 1.5-1.5S17.3 9 16.5 9h-13z"
  })));
};
export default SvgHamburger;